<template>
  <v-dialog
    persistent
    v-model="dialog"
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">Atualização disponível</v-card-title>

      <v-card-text>
        Deseja atualizar agora?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="gray darken-1"
          flat="flat"
          @click="$emit('hide')"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="green darken-4"
          flat="flat"
          @click="$emit('confirm')"
        >
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'update-dialog',

  props: {
    visibility: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    dialog: {
      get () {
        return this.visibility
      },

      set () {
        this.$emit('hide')
      }
    }
  }
}
</script>
